'use es6';

import { fromJS } from 'immutable';
import * as colors from '../../../constants/colors';
export const defaultDatetimeAxisOptions = fromJS({
  type: 'datetime',
  lineColor: colors.LINE_COLOR_DARK,
  lineWidth: 1,
  gridLineColor: colors.LINE_COLOR,
  tickColor: colors.LINE_COLOR_DARK,
  tickPosition: 'inside',
  tickmarkPlacement: 'on',
  tickLength: '5',
  labels: {
    style: {
      color: 'inherit'
    }
  },
  stackLabels: {
    style: {
      color: 'inherit'
    }
  },
  title: {
    text: null,
    style: {
      color: 'inherit',
      fontWeight: 600
    }
  },
  reversedStacks: false
});